module.exports = __webpack_public_path__ + "static/media/people-handshake.3ba76a38.jpg";